import { Navigate, useParams } from 'react-router-dom';
import { Paths } from 'routes/paths';

export function ProductionTasksList() {
  const { id } = useParams();

  return <Navigate to={`${Paths.ProductionWorkflow}/${id}`} />;
}
